import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShipToUnitedStatesComponent } from 'src/app/components/seo-booster-pages/ship-to-united-states/ship-to-united-states.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BoosterRoutingModule } from './booster-routing.module';

@NgModule({
  declarations: [
    ShipToUnitedStatesComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    BoosterRoutingModule

  ],
  providers: [
    
  ]
})
export class BoosterModule { }
